import React, { useState } from "react";
import { string, bool, func } from "prop-types";
import cx from "classnames";
import uniqueid from "lodash.uniqueid";

const propTypes = {
  required: bool,
  error: bool,
  name: string.isRequired,
  label: string.isRequired,
  errorMsg: string,
  onChange: func,
  checked: bool,
  type: string,
};
const defaultProps = {
  className: "",
};

const RadioBox = ({
  required,
  error,
  name,
  label,
  errorMsg,
  onChange,
  checked = false,
  className,
  type = "checkbox",
}) => {
  const uid = uniqueid("radioBox-");
  return (
    <label
      htmlFor={`GUID-${uid}`}
      className={cx("radioBox", [`${className}`], [`radioBox--${type}`], {
        "js-form-required": required,
        "has-error": error,
      })}
    >
      <input
        type={type}
        id={`GUID-${uid}`}
        aria-required={required}
        name={name}
        onChange={onChange}
        className="radioBox__input"
        checked={checked}
      />
      <span className="radioBox__label">
        <span className="radioBox__text">{label}</span>
      </span>
      {errorMsg && (
        <span role="alert" className="radioBox__error">
          {errorMsg}
        </span>
      )}
    </label>
  );
};

RadioBox.defaultProps = defaultProps;
RadioBox.propTypes = propTypes;
export default RadioBox;
